import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import { Ref } from "react";

type PageActions = {
  label: string;
  onClick: () => void;
};

type Props = {
  searchInputRef?: Ref<HTMLInputElement>;
  onSearch: (searchValue: string) => void;
  actions?: PageActions[];
};

export default function SearchHeader({
  searchInputRef,
  onSearch,
  actions,
}: Props) {
  return (
    <div className="z-30 bg-white min-h-[70px]">
      <div className="py-4 px-8 md:flex md:items-center md:justify-between h-full">
        <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
          <form
            className="relative flex flex-1"
            onSubmit={(e) => {
              const searchInput = (
                e.target as unknown as { search: HTMLInputElement }
              ).search;

              onSearch(searchInput.value);
              searchInput.value = "";

              e.preventDefault();
            }}
          >
            <label htmlFor="search-field" className="sr-only">
              Search
            </label>
            <MagnifyingGlassIcon
              className="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-400"
              aria-hidden="true"
            />
            <input
              ref={searchInputRef}
              id="search"
              className="block h-full w-full border-0 py-0 pl-8 pr-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm"
              placeholder="Search..."
              type="text"
              name="search"
            />
          </form>
        </div>
        <div>
          {actions &&
            actions.map((action, index) => (
              <button
                key={index}
                type="button"
                className="block rounded-md bg-sky-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600"
                onClick={action.onClick}
              >
                {action.label}
              </button>
            ))}
        </div>
      </div>
      <div className="relative shadow">
        <div className="inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-200" />
        </div>
      </div>
    </div>
  );
}
